import { apiPathsWithParams, pageSize } from "@src/constants";
import { useQuery } from "@tanstack/react-query";
import { fiveMinutes } from "@src/queries/staletimes";
import { Spaces } from "@src/api/v1/Spaces";
import { ResponseSpacesGetClientSpaceResponsePaginated } from "@src/api/v1/data-contracts";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";

export const useGetClientSpacesQuery = (
  clientId: string | undefined,
  page: number = 0,
  limit: number = pageSize,
) =>
  useQuery<ResponseSpacesGetClientSpaceResponsePaginated>({
    queryKey: [apiPathsWithParams.getClientSpaces(clientId!), page, limit],
    queryFn: () =>
      new Spaces(OpenUpHttpClient).getClientSpaces({
        clientId: clientId!,
        page,
        limit,
      }),
    enabled: !!clientId,
    staleTime: fiveMinutes,
  });
